<template>
  <div class="dashboard_container">
  
	  <div class="tfa-dashboard-section advisor-dashboard-section">
	
		  <div class="top-section row">
		    <div class="dashboard-row stream-section col-9">
		      <div class="">
		        <div class="card">
		          <div class="card-header">
		            <span class="icon icon-student1"></span>
		            <span class="label">Advisee Tracker</span>
		            <div class="more-link test-link"><b-link @click="navigateToTracker()">more</b-link></div>
		          </div>
		          <div class="card-body">
		
		            <div class="course-completion-section row">
		              <dummy-graph ref="DummyGraph"></dummy-graph>
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		
		    <div class="dashboard-row notifications-panel col-3">
		      <div class="">
		        <div class="card">
		          <div class="card-header">
		            <span class="icon icon-bell"></span>
		            <span class="label">Urgent Notifications</span>
		          </div>
		          <div class="card-body notification-content-section">
		            <p class="text-center">No urgent notifications</p>
		            <!--
		            <div class="notifications-row">
		              <div class="message-creator-avatar"><span class="icon-user"></span></div>
		              <div class="msg-section">
		                <div class="user-row">
		                  <span class="user-name-section">Prof. Kandinsky</span>
		                  <span class="time-section">6:18 PM</span>
		                </div>
		                <div class="msg-row">
		                  You have to get my signature for registering in CS400
		                </div>
		              </div>
		            </div>
		
		            <div class="notifications-row">
		              <div class="message-creator-avatar"><span class="icon-user"></span></div>
		              <div class="msg-section">
		                <div class="user-row">
		                  <span class="user-name-section">Prof. Zinn</span>
		                  <span class="time-section">6:18 PM</span>
		                </div>
		                <div class="msg-row">
		                  You have to clear your dues to get the credits
		                </div>
		              </div>
		            </div>
		            -->
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		
		  <div class="bottom-section row">
		    <div class="dashboard-row recommendations-section col-6">
		    				<div class="card">
		    					<div class="card-header">
		    						<span class="icon icon-bullhorn"></span>
		    						<span class="label">Recommendations</span>
		    					</div>
		    					<div class="card-body tab-panel">
		    						<div class="tab-section">
		    							<b-tabs>
		    							  <b-tab title="Academic" active>
		                      <p class="text-center">Coming Soon</p>
		                      <!--
		    								<div class="notifications-row">
		    									<div class="message-creator-avatar"><span class="icon-admin"></span></div>
		    									<div class="msg-section">
		    										<div class="user-row">
		    											<span class="user-name-section">Prof. Kandinsky</span>
		    											<span class="time-section">6:18 PM</span>
		    										</div>
		    										<div class="msg-row">
		    											You have to get my signature for registering in CS400
		    										</div>
		    									</div>
		    								</div>
		
		    								<div class="notifications-row">
		    									<div class="message-creator-avatar"><span class="icon-user"></span></div>
		    									<div class="msg-section">
		    										<div class="user-row">
		    											<span class="user-name-section">Prof. Zinn</span>
		    											<span class="time-section">6:18 PM</span>
		    										</div>
		    										<div class="msg-row">
		    											You have to clear your dues to get the credits
		    										</div>
		    									</div>
		    								</div>
		                    -->
		    							  </b-tab>
		    							  <b-tab title="Co-curricular">
		                      <p class="text-center">Coming Soon</p>
		                      <!--
		    								<div class="notifications-row">
		    									<div class="message-creator-avatar"><span class="icon-admin"></span></div>
		    									<div class="msg-section">
		    										<div class="user-row">
		    											<span class="user-name-section">Prof. Kandinsky</span>
		    											<span class="time-section">6:18 PM</span>
		    										</div>
		    										<div class="msg-row">
		    											You have to get my signature for registering in CS400
		    										</div>
		    									</div>
		    								</div>
		
		    								<div class="notifications-row">
		    									<div class="message-creator-avatar"><span class="icon-user"></span></div>
		    									<div class="msg-section">
		    										<div class="user-row">
		    											<span class="user-name-section">Prof. Zinn</span>
		    											<span class="time-section">6:18 PM</span>
		    										</div>
		    										<div class="msg-row">
		    											You have to clear your dues to get the credits
		    										</div>
		    									</div>
		    								</div>
		                    -->
		    							  </b-tab>
		    							  <b-tab title="People">
		                      <p class="text-center">Coming Soon</p>
		                      <!--
		    								<div class="notifications-row">
		    									<div class="message-creator-avatar"><span class="icon-admin"></span></div>
		    									<div class="msg-section">
		    										<div class="user-row">
		    											<span class="user-name-section">Prof. Kandinsky</span>
		    											<span class="time-section">6:18 PM</span>
		    										</div>
		    										<div class="msg-row">
		    											You have to get my signature for registering in CS400
		    										</div>
		    									</div>
		    								</div>
		
		    								<div class="notifications-row">
		    									<div class="message-creator-avatar"><span class="icon-user"></span></div>
		    									<div class="msg-section">
		    										<div class="user-row">
		    											<span class="user-name-section">Prof. Zinn</span>
		    											<span class="time-section">6:18 PM</span>
		    										</div>
		    										<div class="msg-row">
		    											You have to clear your dues to get the credits
		    										</div>
		    									</div>
		    								</div>
		                    -->
		    							  </b-tab>
		    							</b-tabs>
		    						</div>
		    					</div>
		    				</div>
		    			</div>
		
		    <div class="dashboard-row quick-links col-6">
		      <div class="card">
		        <div class="card-header">
		          <span class="icon icon-link"></span>
		          <span class="label">Quick Links</span>
		        </div>
		        <div class="card-body quick-links-section">
		          <div class="card-content v_scroll">
		                          <div class="quick_link">
		                              <b-nav v-for="quickLink in quickLinks">
		                                  <a :href="quickLink.url" target="_blank" :aria-label="quickLink.title">{{quickLink.title}}</a>
		                              </b-nav>
		                          </div>
		                      </div>
		        </div>
		      </div>
		    </div>
		
		  </div>
	  </div>

  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import DummyGraph from './dummyGraph'

  var staticQuickLinks = function () {
    var quickLinks = [
    ]
    return quickLinks
  }

  export default {
    name: 'advisor-dashboard',
    components: {
      DummyGraph
    },
    props: [],
    data: () => {
      return {
        quickLinks: []
      }
    },

    mounted () {
      this.loadAdvisorDashboard()
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadUpdatePageCount'
      ]),

      loadAdvisorDashboard () {
        this.navigateToTracker()
        this.loadQuickLinks()
        const quickLinks = (this.links.length > 0) ? this.links : staticQuickLinks()
        $.each(quickLinks, (index, quickLink) => {
          this.quickLinks.push(quickLink)
        })
      },

      navigateToTracker () {
        this.loadUpdatePageCount({page: 0, count: 20})
        return this.$router.push({ name: 'adviseeTracker' })
      }
    },

    computed: {
      ...mapState({
        'links': state => state.dashboard.quickLinks
      }),

      username: function () {
        return localStorage.getItem('userFullName')
      }
    }
  }
</script>

<style scoped>
.test-link {
  float: right;
  font-size:16px;
}
.next {
	margin-top: 10%;
}

.icon-master {
	float: right !important;
	margin-top: 0px !important;
	margin-left: 0px !important;
}

.lg_blc {
	width: 30px;
	height: 30px;
	display: inline-block;
	margin: 0px 17px 0px 15px;
}

.status_row {
	display: flex;
	align-items: center;
	height: 45px;
	margin: 10px 0;
	min-width: 241px;
	font-size: 15px;
}

.legend-title {
	padding-left: 15px;
	font-size: 19px;
	font-family: robotoSlab_Light;
	margin-bottom: 17px;
}

.icon-progress {
	font-size: 40px;
	margin: 0 14px 0 15px;
}

.header-title {
	color: #787878;
	font-size: 18px;
	text-align: center;
	padding: 6px 0;
}

.legend-section {
	height: 46px;
    display: flex;
    align-items: center;
	float:right;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/AdvisorDashboard.vue